
export default function Packages() {
  return (
    <section
      id="packages"
      className="bg-[#0d0d0d] py-24 relative overflow-hidden"
    >
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent"></div>
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent"></div>

      <div className="max-w-4xl mx-auto px-6 text-center">
        <div className="mb-10 space-y-4">
          <p className="text-[#D4AF37] text-sm uppercase tracking-[0.3em] font-semibold">
            Pacotes Exclusivos
          </p>
          <h2 className="text-3xl lg:text-4xl font-serif font-bold text-white">
            Conheça Nossos Pacotes{" "}
            <span className="text-[#D4AF37]">PremierNY</span>
          </h2>
        </div>

        <p className="text-gray-300 text-xl lg:text-2xl font-light leading-relaxed mb-6 max-w-3xl mx-auto">
          Oferecemos pacotes personalizados para todo tipo de viajante —
          de roteiros sob medida e passeios guiados a experiências VIP premium.
        </p>
        <p className="text-gray-400 text-lg font-light leading-relaxed mb-12 max-w-2xl mx-auto">
          Cada pacote é cuidadosamente elaborado de acordo com suas preferências,
          estilo de viagem e orçamento. Entre em contato com nossa equipe para
          saber mais e encontrar a experiência perfeita para você.
        </p>

        <div className="grid sm:grid-cols-3 gap-6 mb-14">
          <div className="bg-black border border-[#D4AF37]/30 rounded-2xl p-6 hover:border-[#D4AF37] transition-all duration-300">
            <div className="w-14 h-14 flex items-center justify-center bg-[#D4AF37]/10 rounded-full mx-auto mb-4">
              <i className="ri-route-line text-3xl text-[#D4AF37]"></i>
            </div>
            <h3 className="text-white font-bold text-lg mb-2">
              Roteiros Personalizados
            </h3>
            <p className="text-gray-400 text-sm">
              Planos dia a dia criados especialmente para você
            </p>
          </div>

          <div className="bg-black border border-[#D4AF37]/30 rounded-2xl p-6 hover:border-[#D4AF37] transition-all duration-300">
            <div className="w-14 h-14 flex items-center justify-center bg-[#D4AF37]/10 rounded-full mx-auto mb-4">
              <i className="ri-group-line text-3xl text-[#D4AF37]"></i>
            </div>
            <h3 className="text-white font-bold text-lg mb-2">
              Experiências Guiadas
            </h3>
            <p className="text-gray-400 text-sm">
              Passeios com especialistas e suporte em português
            </p>
          </div>

          <div className="bg-black border border-[#D4AF37]/30 rounded-2xl p-6 hover:border-[#D4AF37] transition-all duration-300">
            <div className="w-14 h-14 flex items-center justify-center bg-[#D4AF37]/10 rounded-full mx-auto mb-4">
              <i className="ri-vip-crown-line text-3xl text-[#D4AF37]"></i>
            </div>
            <h3 className="text-white font-bold text-lg mb-2">VIP Premium</h3>
            <p className="text-gray-400 text-sm">
              Acesso exclusivo e serviço de concierge de luxo
            </p>
          </div>
        </div>

        <a
          href="https://wa.me/16466330270"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-8 py-4 bg-[#D4AF37] text-black font-bold text-base rounded-full hover:bg-[#C5A028] transition-all duration-300 shadow-2xl hover:shadow-[#D4AF37]/50 whitespace-nowrap"
        >
          <i className="ri-whatsapp-line text-xl"></i>
          Saiba mais sobre nossos pacotes
        </a>

        <p className="text-gray-500 text-sm mt-6">
          Todos os pacotes podem ser totalmente personalizados de acordo com
          suas necessidades.
        </p>
      </div>
    </section>
  );
}
